<div class="lines-container">
    <!-- Nós de expansão circular (Cor Primária) -->
    <div class="node"></div>
    <div class="node"></div>
    <div class="node"></div>
    <div class="node"></div>
    <div class="node"></div>
    <div class="node"></div>

    <!-- Linhas estruturais dinâmicas (Cor Primária) -->
    <div class="random-line line-1"></div>
    <div class="random-line line-2"></div>
    <div class="random-line line-3"></div>
    <div class="random-line line-4"></div>
</div>
